exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-info {\n  font-weight: 400 !important;\n  word-wrap: break-word;\n}\n\n.asset-heading {\n  font-size:15px !important;\n  margin-top:5px;\n  background-color: #f1f1f1;\n  width: 300px;\n}\n\n.status-asset-heading {\n  background-color: #f44336;\n  color: white;\n  opacity: 0.83;\n}\n\n.modal-container {\n  width:1070px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/media-modal/media-modal.component.css
// module id = ../../../../../src/app/media-modal/media-modal.component.css
// module chunks = 1